import React from "react";
import { Pagination as MantinePagination } from "@mantine/core";

export interface PagintaionProps {
  total: number;
  perPage: number;
  currentPage: number;
  setCurrentPage(num: number): void;
}

const Pagination: React.FC<PagintaionProps> = ({
  total,
  perPage,
  currentPage,
  setCurrentPage,
}) => {
  const totalPages = Math.ceil(total / perPage);
  if (total === 0 || totalPages < 1) {
    return null;
  }

  return (
    <MantinePagination
      total={totalPages}
      value={currentPage}
      onChange={setCurrentPage}
      withEdges
      mt="md"
    />
  );
};

export default Pagination;
